<div id="power-gauge"></div>
